
export const GET_NUMBER_POOLS = 'getNumberPools'; 
export const GET_NUMBER_POOL = 'getNumberPool'; 
export const GET_NUMBER_ORDERS = 'getNumberOrders';
export const GET_PENDING_NUMBER_ORDERS = 'getPendingNumberOrders';
export const GET_NUMBER_ORDER = 'getNumberOrder';
export const CANCEL_NUMBER_ORDER = 'cancelNumberOrder';
export const SELECT_NUMBER_ORDER = 'selectNumberOrder';
export const UNSELECT_NUMBER_ORDER = 'unselectNumberOrder';
export const CREATE_NUMBER = 'CREATE_NUMBER';
export const EDIT_NUMBER = 'EDIT_NUMBER';
export const CREATE_NUMBER_ORDER = 'CREATE_NUMBER_ORDER';
export const ATTACH_PUBLISHER_TO_NUMBER = 'ATTACH_PUBLISHER_TO_NUMBER';
export const CREATE_NUMBER_POOL =  'CREATE_NUMBER_POOL'; 
export const EDIT_NUMBER_POOL = 'EDIT_NUMBER_POOL'; 
export const GROW_NUMBER_POOL = 'GROW_NUMBER_POOL';
export const SHRINK_NUMBER_POOL = 'SHRINK_NUMBER_POOL';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';   
export const DELETE_NUMBER_POOL = 'DELETE_NUMBER_POOL';
export const GET_NUMBER_POOL_REFERENCES = 'GET_NUMBER_POOL_REFERENCES';
export const GET_ACCOUNT_SETTINGS = 'GET_ACCOUNT_SETTINGS';
export const SET_WIDGET_TITLE = 'setWidgetTitle';
export const GET_NUMBER_AVAILABLE_COUNTRIES = 'GET_NUMBER_AVAILABLE_COUNTRIES';